import * as React from 'react';

import { getTermValue } from 'shared/common/packages/JsonQuery';
import { ESuburbanWCType } from 'shared/common/packages/api-models/common/json_query';

import { SuburbanBathroom } from '../../../components/advancedFilters/SuburbanBathroom';
import { useContext } from '../../../utils/useContext';

export const SuburbanBathroomContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const suburbanBathroomType = getTermValue('wc_site')(jsonQuery);

  const handleChange = React.useCallback(
    (suburbanBathroomType: ESuburbanWCType | null) => {
      onChange({ action: 'setSuburbanBathroomType', arguments: [suburbanBathroomType] });
    },
    [onChange],
  );

  return <SuburbanBathroom value={suburbanBathroomType} onChange={handleChange} />;
};
